'use client';

import { faArrowRight } from '@fortawesome/pro-regular-svg-icons';
import { Image } from '@heroui/image';
import { Link } from '@heroui/link';
import { FC } from 'react';
import { Icon } from '../ui';

const PageNotFound: FC = () => {
  return (
    <div className="flex items-center justify-center py-16">
      <div className="flex max-w-md flex-col items-start justify-center space-y-4 p-8">
        <h1 className="text-4xl font-medium text-gray-800"> Oops! Page not found. </h1>
        <p className="text-lg text-gray-600">
          It seems the page you are looking for does not exist. Check the URL or return to the
          homepage.
        </p>
        <Link href="/">
          <span>Back to homepage</span>
          <Icon icon={faArrowRight} className="ml-2 h-5 w-5" />
        </Link>
      </div>

      <div className="hidden max-w-lg md:block">
        <Image
          src="/imgs/404-image.png"
          alt="404 Image"
          width={512}
          height={410}
          className="h-full w-full object-contain"
        />
      </div>
    </div>
  );
};

export default PageNotFound;
